import { render, staticRenderFns } from "./OnlineAuth.vue?vue&type=template&id=7f54b07a&"
import script from "./OnlineAuth.vue?vue&type=script&lang=js&"
export * from "./OnlineAuth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports